<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <section class="ank--hero">
      <div class="container">
        <div class="ank--hero-shell">
          <div class="ank--hero-content">
            <div class="ank--hero-left">
              <div class="ank--badge-pill">{{ $t('home.sidebarMenu.agenNaikKelas') }}</div>
              <h1 class="ank--title">
                {{ $t('agenNaikKelasPage.title1') }}
                <span>{{ $t('agenNaikKelasPage.title2') }}</span>
              </h1>
              <div class="ank--subtitle">{{ $t('agenNaikKelasPage.subtitle') }}</div>
              <div class="ank--benefit-list">
                <div class="ank--benefit-item">
                  <span class="ank--benefit-mark"></span>
                  <div>{{ $t('agenNaikKelasPage.benefit1') }}</div>
                </div>
                <div class="ank--benefit-item">
                  <span class="ank--benefit-mark"></span>
                  <div>{{ $t('agenNaikKelasPage.benefit2') }}</div>
                </div>
                <div class="ank--benefit-item">
                  <span class="ank--benefit-mark"></span>
                  <div>{{ $t('agenNaikKelasPage.benefit3') }}</div>
                </div>
              </div>
              <div v-if="loggedIn" class="ank--progress-inline-wrap">
                <agen-naik-kelas-progress :inline="true" :show-when-complete="true" />
              </div>
            </div>
            <div class="ank--hero-right">
              <router-link to="/agen-naik-kelas" class="ank--badge-showcase">
                <img
                  src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/agen-naik-kelas/agen-naik-kelas-badge.svg"
                  alt="Agen Naik Kelas Badge"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="ank--section">
      <div class="container">
        <div class="ank--section-heading">
          <div class="ank--section-kicker">{{ $t('home.sidebarMenu.agenNaikKelas') }}</div>
          <h2 class="ank--section-title">{{ $t('agenNaikKelasPage.requirementTitle') }}</h2>
        </div>
        <div class="ank--card">
          <ol>
            <li>
              {{ $t('agenNaikKelasPage.requirement1') }}
              <ul>
                <li>{{ $t('agenNaikKelasPage.requirement2a') }}</li>
                <li class="normal--text">atau</li>
                <li>{{ $t('agenNaikKelasPage.requirement2b') }}</li>
              </ul>
            </li>
            <li>{{ $t('agenNaikKelasPage.requirement2') }}</li>
            <li>{{ $t('agenNaikKelasPage.requirement3') }}</li>
            <li>{{ $t('agenNaikKelasPage.requirement4') }}</li>
            <li>{{ $t('agenNaikKelasPage.requirement5') }}</li>
            <li>{{ $t('agenNaikKelasPage.requirement6') }}</li>
          </ol>
        </div>
      </div>
    </section>

    <section class="ank--section ank--section-last">
      <div class="container">
        <div class="ank--section-heading">
          <div class="ank--section-kicker">{{ $t('home.sidebarMenu.agenNaikKelas') }}</div>
          <h2 class="ank--section-title">{{ $t('agenNaikKelasPage.flowTitle') }}</h2>
        </div>
        <div class="ank--flow-wrapper">
          <img
            class="ank--flow-image-web"
            src="@/assets/img/agen-naik-kelas/alurbadgeweb.svg"
            alt="Alur Agen Naik Kelas"
          />
          <img
            class="ank--flow-image-mobile"
            src="@/assets/img/agen-naik-kelas/alurbadgemobile.svg"
            alt="Alur Agen Naik Kelas Mobile"
          />
        </div>
      </div>
    </section>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';
import AgenNaikKelasProgress from '@/components/utils/agen-naik-kelas-progress.vue';
import { mapState } from 'vuex';

export default {
  name: 'agen-naik-kelas',
  mixins: [DefaultHeadMixin],
  async fetch({ store }) {
    const url = 'https://agen.belirumah.co/layanan-agen/agen-naik-kelas';
    const title =
      'Agen Naik Kelas | Badge Agen Properti Terpercaya dan Profesional | Agen BeliRumah.co';
    const description =
      'Dapatkan badge Agen Naik Kelas untuk meningkatkan kredibilitas sebagai agen properti terverifikasi dan bangun kepercayaan calon buyer';

    store.commit('head/SET_CONTENT', {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'og-url', property: 'og:url', content: url },
        { hid: 'og-type', property: 'og:type', content: 'website' },
        { hid: 'og-description', property: 'og:description', content: description },
      ],
      link: [{ rel: 'canonical', href: url, id: 'canonical' }],
    });
  },
  components: {
    AgenNaikKelasProgress,
    DefaultLayout,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.global.loggedIn,
    }),
    breadcrumbs() {
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: this.$t('home.sidebarMenu.agenNaikKelas'),
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/pages/agen-naik-kelas';

.ank--progress-inline-wrap {
  display: flex;
  justify-content: flex-start;
}
</style>
